
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 16a.993.993 0 01-.64-.232l-6-5a1 1 0 111.28-1.536l5.371 4.476 5.362-4.315a1 1 0 011.254 1.558l-6 4.828A1 1 0 0112 16z"}}),_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"5","y":"9","width":"14","height":"7"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 16a.993.993 0 01-.64-.232l-6-5a1 1 0 111.28-1.536l5.371 4.476 5.362-4.315a1 1 0 011.254 1.558l-6 4.828A1 1 0 0112 16z"}})])])
          )
        }
      }
    